// import React, { useState, useEffect } from "react";
// import { FaIdBadge, FaUser, FaUserFriends } from "react-icons/fa";
// import "./FDD.css";

// const FDMIS = () => {
//   // Top calculation states
//   const [accountType, setAccountType] = useState("FD"); // FD or MIS
//   const [scheme, setScheme] = useState("");
//   const [roi, setRoi] = useState(""); // percent
//   const [minDeposit, setMinDeposit] = useState("");
//   const [minTenure, setMinTenure] = useState("");
//   const [installmentFrequency, setInstallmentFrequency] = useState("");
//   const [lockinPeriod, setLockinPeriod] = useState("");
//   const [interestLockin, setInterestLockin] = useState("");
//   const [compoundingType, setCompoundingType] = useState("Simple");
//   const [depositAmount, setDepositAmount] = useState("");
//   const [tenureMonths, setTenureMonths] = useState("");

//   // MIS fields
//   const [payoutFrequency, setPayoutFrequency] = useState("");
//   const monthlyInterest = accountType === "MIS" && depositAmount && roi
//     ? ((depositAmount * roi) / 1200).toFixed(2)
//     : "";

//   // Results
//   const [principalAmount, setPrincipalAmount] = useState(0);
//   const [totalInterest, setTotalInterest] = useState(0);
//   const [maturityAmount, setMaturityAmount] = useState(0);
//   const [showChart, setShowChart] = useState(false);

//   // Customer
//   const [customerId, setCustomerId] = useState("");
//   const [customerLoading, setCustomerLoading] = useState(false);
//   const [customerData, setCustomerData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     aadhar: "",
//     pan: "",
//     dob: "",
//     address: "",
//   });

//   // Nominee
//   const [nomineeId, setNomineeId] = useState("");
//   const [nomineeLoading, setNomineeLoading] = useState(false);
//   const [nomineeData, setNomineeData] = useState({
//     nomineeName: "",
//     dob: "",
//     aadhar: "",
//     pan: "",
//     mobile: "",
//     address: "",
//   });
//   const [relation, setRelation] = useState("");
//   const [payoutType, setPayoutType] = useState("Maturity Payout");

//   // Referral
//   const [referralId, setReferralId] = useState("");
//   const [referralName, setReferralName] = useState("");

//   // Payment
//   const [paymentMode, setPaymentMode] = useState("");
//   const [receiptNumber, setReceiptNumber] = useState("");
//   const [chequeNumber, setChequeNumber] = useState("");
//   const [bankName, setBankName] = useState("");
//   const [chequeDate, setChequeDate] = useState("");
//   const [upiId, setUpiId] = useState("");
//   const [transactionId, setTransactionId] = useState("");

//   // ---------- Mock API helpers ----------
//   const fetchCustomer = async (id) => {
//     setCustomerLoading(true);
//     return new Promise((res) =>
//       setTimeout(() => {
//         setCustomerLoading(false);
//         res({
//           name: "John FD",
//           email: "john@example.com",
//           phone: "9876543210",
//           aadhar: "111122223333",
//           pan: "ABCDE1234F",
//           dob: "1990-01-01",
//           address: "12 Bank Street",
//         });
//       }, 900)
//     );
//   };

//   const fetchNominee = async (id) => {
//     setNomineeLoading(true);
//     return new Promise((res) =>
//       setTimeout(() => {
//         setNomineeLoading(false);
//         res({
//           nomineeName: "Jane FD",
//           dob: "1995-05-05",
//           aadhar: "444433332222",
//           pan: "XYZAB1234C",
//           mobile: "9876500000",
//           address: "45 Branch Road",
//         });
//       }, 900)
//     );
//   };

//   useEffect(() => {
//     if (customerId) fetchCustomer(customerId).then(setCustomerData);
//     else
//       setCustomerData({
//         name: "",
//         email: "",
//         phone: "",
//         aadhar: "",
//         pan: "",
//         dob: "",
//         address: "",
//       });
//   }, [customerId]);

//   useEffect(() => {
//     if (nomineeId) fetchNominee(nomineeId).then(setNomineeData);
//     else
//       setNomineeData({
//         nomineeName: "",
//         dob: "",
//         aadhar: "",
//         pan: "",
//         mobile: "",
//         address: "",
//       });
//   }, [nomineeId]);

//   // ---------- Calculation ----------
//   const calculateFD = () => {
//     const P = parseFloat(depositAmount || 0);
//     const r = parseFloat(roi || 0) / 100;
//     const n = 12;
//     const t = parseFloat(tenureMonths || 0) / 12;

//     if (!P || !r || !t) {
//       setPrincipalAmount(0);
//       setTotalInterest(0);
//       setMaturityAmount(0);
//       return;
//     }

//     if (accountType === "MIS") {
//       const monthlyInt = (P * r) / 12;
//       setPrincipalAmount(P);
//       setTotalInterest(monthlyInt * tenureMonths);
//       setMaturityAmount(P + monthlyInt * tenureMonths);
//       return;
//     }

//     if (compoundingType === "Compound") {
//       const A = P * Math.pow(1 + r / n, n * t);
//       setMaturityAmount(parseFloat(A.toFixed(2)));
//       setPrincipalAmount(P);
//       setTotalInterest(parseFloat((A - P).toFixed(2)));
//     } else {
//       const A = P * (1 + r * t);
//       setMaturityAmount(parseFloat(A.toFixed(2)));
//       setPrincipalAmount(P);
//       setTotalInterest(parseFloat((A - P).toFixed(2)));
//     }
//   };

//   const resetTop = () => {
//     setAccountType("FD");
//     setScheme("");
//     setRoi("");
//     setMinDeposit("");
//     setMinTenure("");
//     setInstallmentFrequency("");
//     setLockinPeriod("");
//     setInterestLockin("");
//     setCompoundingType("Simple");
//     setDepositAmount("");
//     setTenureMonths("");
//     setPayoutFrequency("");
//     setPrincipalAmount(0);
//     setTotalInterest(0);
//     setMaturityAmount(0);
//   };

//   const handleOpenFD = (e) => {
//     e.preventDefault();

//     const payload = {
//       accountType,
//       scheme,
//       roi,
//       depositAmount,
//       tenureMonths,
//       compoundingType,
//       payoutFrequency,
//       customer: { id: customerId, ...customerData },
//       nominee: { id: nomineeId, ...nomineeData, relation },
//       referral: { id: referralId, name: referralName },
//       payment: { paymentMode, receiptNumber, chequeNumber, bankName, chequeDate, upiId, transactionId },
//     };

//     console.log("Open FD payload:", payload);
//     alert("FD/MIS account opened (mock). Check console for payload.");
//   };

//   const handlePaymentModeChange = (mode) => {
//     setPaymentMode(mode);
//     setReceiptNumber("");
//     setChequeNumber("");
//     setBankName("");
//     setChequeDate("");
//     setUpiId("");
//     setTransactionId("");
//   };

//   return (
//     <div className="fd-mis-container">

//       {/* Top FD/MIS Grid */}
//       <div className="fd-mis-form-grid" style={{ marginBottom: 20 }}>

//         {/* ACCOUNT TYPE */}
//         <div className="fd-mis-input-fields">
//           <label className="fd-mis-label">Account Type :</label>
//           <select value={accountType} onChange={(e) => setAccountType(e.target.value)} className="fd-mis-input">
//             <option>FD</option>
//             <option>MIS</option>
//           </select>
//         </div>

//         {/* Scheme */}
//         <div className="fd-mis-input-fields">
//           <label className="fd-mis-label">Select Scheme :</label>
//           <select value={scheme} onChange={(e) => setScheme(e.target.value)} className="fd-mis-input">
//             <option value="">-- Select Scheme --</option>
//             <option value="Regular FD">Regular FD</option>
//             <option value="Senior Citizen FD">Senior Citizen FD</option>
//             <option value="MIS">MIS</option>
//           </select>
//         </div>

//         {/* ROI */}
//         <div className="fd-mis-input-fields">
//           <label className="fd-mis-label">ROI (%) :</label>
//           <input value={roi} onChange={(e) => setRoi(e.target.value)} className="fd-mis-input" placeholder="7.00" />
//         </div>

//         {/* Min Deposit */}
//         <div className="fd-mis-input-fields">
//           <label className="fd-mis-label">Min Deposit Amount :</label>
//           <input value={minDeposit} onChange={(e) => setMinDeposit(e.target.value)} className="fd-mis-input" />
//         </div>

//         {/* Min Tenure */}
//         <div className="fd-mis-input-fields">
//           <label className="fd-mis-label">Min Tenure :</label>
//           <input value={minTenure} onChange={(e) => setMinTenure(e.target.value)} className="fd-mis-input" />
//         </div>

//         {/* IF */}
//         <div className="fd-mis-input-fields">
//           <label className="fd-mis-label">Installment Frequency :</label>
//           <input value={installmentFrequency} onChange={(e) => setInstallmentFrequency(e.target.value)} className="fd-mis-input" />
//         </div>

//         {/* Lockin */}
//         <div className="fd-mis-input-fields">
//           <label className="fd-mis-label">Lockin Period (Months):</label>
//           <input value={lockinPeriod} onChange={(e) => setLockinPeriod(e.target.value)} className="fd-mis-input" />
//         </div>

//         {/* Interest Lockin */}
//         <div className="fd-mis-input-fields">
//           <label className="fd-mis-label">Interest Lockin (Months):</label>
//           <input value={interestLockin} onChange={(e) => setInterestLockin(e.target.value)} className="fd-mis-input" />
//         </div>

//         {/* Compounding */}
//         <div className="fd-mis-input-fields">
//           <label className="fd-mis-label">Compounding Type :</label>
//           <select value={compoundingType} onChange={(e) => setCompoundingType(e.target.value)} className="fd-mis-input">
//             <option>Simple</option>
//             <option>Compound</option>
//           </select>
//         </div>

//         {/* Deposit Amount */}
//         <div className="fd-mis-input-fields">
//           <label className="fd-mis-label">Enter Deposit Amount :</label>
//           <input type="number" value={depositAmount} onChange={(e) => setDepositAmount(e.target.value)} className="fd-mis-input" />
//         </div>

//         {/* Tenure */}
//         <div className="fd-mis-input-fields">
//           <label className="fd-mis-label">Enter Tenure (Months) :</label>
//           <input type="number" value={tenureMonths} onChange={(e) => setTenureMonths(e.target.value)} className="fd-mis-input" />
//         </div>

//         {/* 🔥 MIS Fields */}
//         {accountType === "MIS" && (
//           <>
//             <div className="fd-mis-input-fields">
//               <label className="fd-mis-label">Interest Payout Frequency :</label>
//               <select value={payoutFrequency} onChange={(e) => setPayoutFrequency(e.target.value)} className="fd-mis-input">
//                 <option value="">Select</option>
//                 <option value="Monthly">Monthly</option>
//                 <option value="Quarterly">Quarterly</option>
//               </select>
//             </div>

//             <div className="fd-mis-input-fields">
//               <label className="fd-mis-label">Monthly Interest :</label>
//               <input className="fd-mis-input" readOnly value={monthlyInterest} placeholder="0.00" />
//             </div>
//           </>
//         )}
//       </div>

//       {/* Buttons */}
//       <div style={{ marginBottom: 18 }}>
//         <button className="FDnext-btn" onClick={() => { calculateFD(); setShowChart(true); }} style={{ marginRight: 12 }}>
//           Calculate
//         </button>
//         <button className="FDreset-btn" onClick={resetTop} style={{ marginRight: 12 }}>
//           Reset
//         </button>
//       </div>

//       {/* Results */}
//       <div className="fd-mis-results-container" style={{ marginBottom: 20 }}>
//         <div style={{ background: "linear-gradient(90deg,#3bb7ff,#00e0a8)", padding: 12, borderRadius: 6, color: "#fff", marginBottom: 12 }}>
//           Results
//         </div>

//         <div style={{ display: "grid", gridTemplateColumns: "1fr 120px", rowGap: 14, alignItems: "center" }}>
//           <div>Principal Amount:</div>
//           <div style={{ textAlign: "right" }}>₹ {principalAmount.toFixed(2)}</div>

//           <div>Total Interest:</div>
//           <div style={{ textAlign: "right" }}>₹ {totalInterest.toFixed(2)}</div>

//           <div>Maturity Amount:</div>
//           <div style={{ textAlign: "right" }}>₹ {maturityAmount.toFixed(2)}</div>
//         </div>
//       </div>

//       {/* CUSTOMER / NOMINEE / REFERRAL & PAYMENT remain unchanged */}

//       {/* CUSTOMER CARD */}
//       <div className="fd-mis-results-container">
//         <h2 className="fd-mis-h2"><FaUser /> Customer Details</h2>

//         <div className="FDNom-row-box">
//           <div className="FDNom-label-cell">Customer ID:</div>
//           <div className="FDNom-value-cell">
//             <input placeholder="Enter Customer ID" value={customerId} onChange={(e) => setCustomerId(e.target.value)} />
//           </div>

//           <div className="FDNom-label-cell">User Name:</div>
//           <div className="FDNom-value-cell">
//             <input placeholder="User Name" value={customerData.name} onChange={(e) => setCustomerData({ ...customerData, name: e.target.value })} />
//           </div>

//           <div className="FDNom-label-cell">Email:</div>
//           <div className="FDNom-value-cell">
//             <input placeholder="Email" value={customerData.email} onChange={(e) => setCustomerData({ ...customerData, email: e.target.value })} />
//           </div>

//           <div className="FDNom-label-cell">Phone:</div>
//           <div className="FDNom-value-cell">
//             <input placeholder="Phone" value={customerData.phone} onChange={(e) => setCustomerData({ ...customerData, phone: e.target.value })} />
//           </div>

//           <div className="FDNom-label-cell">Aadhar:</div>
//           <div className="FDNom-value-cell">
//             <input placeholder="Aadhar" value={customerData.aadhar} onChange={(e) => setCustomerData({ ...customerData, aadhar: e.target.value })} />
//           </div>

//           <div className="FDNom-label-cell">PAN:</div>
//           <div className="FDNom-value-cell">
//             <input placeholder="PAN" value={customerData.pan} onChange={(e) => setCustomerData({ ...customerData, pan: e.target.value })} />
//           </div>

//           <div className="FDNom-label-cell">Date of Birth:</div>
//           <div className="FDNom-value-cell">
//             <input type="date" value={customerData.dob} onChange={(e) => setCustomerData({ ...customerData, dob: e.target.value })} />
//           </div>

//           <div className="FDNom-label-cell">Address:</div>
//           <div className="FDNom-value-cell">
//             <input placeholder="Address" value={customerData.address} onChange={(e) => setCustomerData({ ...customerData, address: e.target.value })} />
//           </div>
//         </div>

//         {customerLoading && <p className="FDloading-text">Loading customer data...</p>}
//       </div>

//       {/* NOMINEE */}
//       <div className="fd-mis-results-container">
//         <h2 className="fd-mis-h2"><FaUserFriends /> Nominee Details</h2>

//         <div className="FDNom-row-box">
//           <div className="FDNom-label-cell">Nominee ID:</div>
//           <div className="FDNom-value-cell">
//             <input placeholder="Enter Nominee ID" value={nomineeId} onChange={(e) => setNomineeId(e.target.value)} />
//           </div>

//           <div className="FDNom-label-cell">Nominee Name:</div>
//           <div className="FDNom-value-cell">
//             <input placeholder="Nominee Name" value={nomineeData.nomineeName} onChange={(e) => setNomineeData({ ...nomineeData, nomineeName: e.target.value })} />
//           </div>

//           <div className="FDNom-label-cell">DOB:</div>
//           <div className="FDNom-value-cell">
//             <input type="date" value={nomineeData.dob} onChange={(e) => setNomineeData({ ...nomineeData, dob: e.target.value })} />
//           </div>

//           <div className="FDNom-label-cell">Aadhar:</div>
//           <div className="FDNom-value-cell">
//             <input placeholder="Aadhar" value={nomineeData.aadhar} onChange={(e) => setNomineeData({ ...nomineeData, aadhar: e.target.value })} />
//           </div>

//           <div className="FDNom-label-cell">PAN:</div>
//           <div className="FDNom-value-cell">
//             <input placeholder="PAN" value={nomineeData.pan} onChange={(e) => setNomineeData({ ...nomineeData, pan: e.target.value })} />
//           </div>

//           <div className="FDNom-label-cell">Mobile:</div>
//           <div className="FDNom-value-cell">
//             <input placeholder="Mobile" value={nomineeData.mobile} onChange={(e) => setNomineeData({ ...nomineeData, mobile: e.target.value })} />
//           </div>

//           <div className="FDNom-label-cell">Relation:</div>
//           <div className="FDNom-value-cell">
//             <select value={relation} onChange={(e) => setRelation(e.target.value)}>
//               <option value="">Select</option>
//               <option>Father</option>
//               <option>Mother</option>
//               <option>Spouse</option>
//               <option>Son</option>
//               <option>Daughter</option>
//             </select>
//           </div>

//           <div className="FDNom-label-cell">Payout Type:</div>
//           <div className="FDNom-value-cell">
//             <select value={payoutType} onChange={(e) => setPayoutType(e.target.value)}>
//               <option>Maturity Payout</option>
//               <option>Reinvest</option>
//               <option>Monthly Payout (MIS)</option>
//             </select>
//           </div>
//         </div>

//         {nomineeLoading && <p className="FDloading-text">Loading nominee data...</p>}
//       </div>

//       {/* REFERRAL */}
//       <div className="fd-mis-results-container">
//         <h2 className="fd-mis-h2"><FaIdBadge /> Referral Details</h2>

//         <div className="FDRef-row-horizontal">
//           <div className="FDRef-column">
//             <label>Referral ID</label>
//             <input placeholder="Enter Referral ID" value={referralId} onChange={(e) => setReferralId(e.target.value)} />
//           </div>
//           <div className="FDRef-column">
//             <label>Referral Name</label>
//             <input placeholder="Referral Name" value={referralName} onChange={(e) => setReferralName(e.target.value)} />
//           </div>
//         </div>

//         <div style={{ marginTop: 16 }}>
//           <button className="FDsub" onClick={handleOpenFD}>Open FD / MIS</button>
//         </div>
//       </div>

//       {/* PAYMENT */}
//       <div className="FDpayment-form-container" style={{ marginBottom: 40 }}>
//         <h2 className="FDform-title">Make a Payment (Optional)</h2>

//         <form onSubmit={(e) => { e.preventDefault(); alert("Payment recorded (mock)"); }}>
//           <div className="FDform-row">
//             <div className="FDform-group">
//               <label>Amount</label>
//               <div className="FDamount-input-group">
//                 <span className="FDcurrency-symbol">₹</span>
//                 <input type="number" value={depositAmount} onChange={(e) => setDepositAmount(e.target.value)} />
//               </div>
//             </div>

//             <div className="FDform-group">
//               <label>Transfer Date</label>
//               <input type="date" value={chequeDate} onChange={(e) => setChequeDate(e.target.value)} />
//             </div>
//           </div>

//           <div className="FDform-group">
//             <label>Payment Mode</label>
//             <div className="FDradio-options">
//               <label>
//                 <input type="radio" name="paymentMode" checked={paymentMode === "cash"} onChange={() => handlePaymentModeChange("cash")} /> Cash
//               </label>
//               <label>
//                 <input type="radio" name="paymentMode" checked={paymentMode === "cheque"} onChange={() => handlePaymentModeChange("cheque")} /> Cheque
//               </label>
//               <label>
//                 <input type="radio" name="paymentMode" checked={paymentMode === "online"} onChange={() => handlePaymentModeChange("online")} /> Online
//               </label>
//             </div>
//           </div>

//           {paymentMode === "cash" && (
//             <div className="FDcash-fields">
//               <div className="FDform-group">
//                 <label>Receipt Number</label>
//                 <input value={receiptNumber} onChange={(e) => setReceiptNumber(e.target.value)} />
//               </div>
//             </div>
//           )}

//           {paymentMode === "cheque" && (
//             <div className="FDcheque-fields">
//               <div className="FDform-group">
//                 <label>Cheque Number</label>
//                 <input value={chequeNumber} onChange={(e) => setChequeNumber(e.target.value)} />
//               </div>
//               <div className="FDform-group">
//                 <label>Bank Name</label>
//                 <input value={bankName} onChange={(e) => setBankName(e.target.value)} />
//               </div>
//               <div className="FDform-group">
//                 <label>Cheque Date</label>
//                 <input type="date" value={chequeDate} onChange={(e) => setChequeDate(e.target.value)} />
//               </div>
//             </div>
//           )}

//           {paymentMode === "online" && (
//             <div className="FDonline-fields">
//               <div className="FDform-group">
//                 <label>UPI / Account No</label>
//                 <input value={upiId} onChange={(e) => setUpiId(e.target.value)} />
//               </div>
//               <div className="FDform-group">
//                 <label>Transaction ID</label>
//                 <input value={transactionId} onChange={(e) => setTransactionId(e.target.value)} />
//               </div>
//             </div>
//           )}

//           <button type="submit" className="FDsubmit-button">Record Payment</button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default FDMIS;

// -------------------------------------------

// import React, { useState, useEffect, useRef } from "react";
// import { FaIdBadge, FaUser, FaUserFriends } from "react-icons/fa";
// import "./FDD.css";
// import { Chart as ChartJS } from "chart.js/auto";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
// import axios from "axios";

// const FDMIS = () => {
//   const dispatch = useDispatch();
//   const canvasRef = useRef(null);
//   const chartRef = useRef(null);
//   const { profile } = useSelector((state) => state.userProfile);

//   // Top calculation states
//   const [accountType, setAccountType] = useState("FD"); // FD or MIS
//   const [roi, setRoi] = useState(""); // percent
//   const [minDeposit, setMinDeposit] = useState("");
//   const [minTenure, setMinTenure] = useState("");
//   const [installmentFrequency, setInstallmentFrequency] = useState("");
//   const [lockinPeriod, setLockinPeriod] = useState("");
//   const [interestLockin, setInterestLockin] = useState("");
//   const [compoundingType, setCompoundingType] = useState("Simple");
//   const [tenureMonths, setTenureMonths] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [customerLoading, setCustomerLoading] = useState(false);
//   const [nomineeLoading, setNomineeLoading] = useState(false);

//   // Schemes
//   const [schemes, setSchemes] = useState([]);
//   const [selectedSchemeId, setSelectedSchemeId] = useState("");
//   const [selectedScheme, setSelectedScheme] = useState(null);
//   const [submitting, setSubmitting] = useState(false);

//   const [savingAccounts, setSavingAccounts] = useState([]);
//   const [deductionType, setDeductionType] = useState("manual"); // 'linked' or 'manual'
//   const [selectedSavingAccount, setSelectedSavingAccount] = useState("");

//   // Customer
//   const [customerId, setCustomerId] = useState("");
//   const [customerData, setCustomerData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     aadhar: "",
//     pan: "",
//     dob: "",
//     address: "",
//   });

//   // Nominee
//   const [nomineeId, setNomineeId] = useState("");
//   const [nomineeData, setNomineeData] = useState({
//     nomineeName: "",
//     dob: "",
//     aadhar: "",
//     pan: "",
//     mobile: "",
//     nomineeRelation:""
//   });

//   // Results
//   const [depositAmount, setDepositAmount] = useState("");
//   const [principalAmount, setPrincipalAmount] = useState(0);
//   const [totalInterest, setTotalInterest] = useState(0);
//   const [maturityAmount, setMaturityAmount] = useState(0);
//   const [results, setResults] = useState({
//     principal: 0,
//     totalInterest: 0,
//     maturityAmount: 0,
//     monthlyInterest: 0,
//   });

//   // MIS fields
//   const [payoutFrequency, setPayoutFrequency] = useState("");

//   // Calculation states
//   const [amount, setAmount] = useState("");
//   const [tenure, setTenure] = useState("");
//   const [viewChart, setViewChart] = useState(false);

//   const [relation, setRelation] = useState("");
//   const [payoutType, setPayoutType] = useState("Maturity Payout");

//   // Referral
//   const [referId, setreferId] = useState("");
//   const [referralName, setReferralName] = useState("");

//   // Payment
//   // const [paymentMode, setPaymentMode] = useState("");
//   // const [receiptNumber, setReceiptNumber] = useState("");
//   // const [chequeNumber, setChequeNumber] = useState("");
//   // const [bankName, setBankName] = useState("");
//   // const [chequeDate, setChequeDate] = useState("");
//   // const [upiId, setUpiId] = useState("");
//   // const [transactionId, setTransactionId] = useState("");

//   // ------------------Api fetching---------------
//   useEffect(() => {
//     dispatch(fetchUserProfile());
//   }, [dispatch]);

//   // ------------------------------------------
//   // FINAL REFERRAL AUTO-FETCH USE EFFECT
//   // Supports: EMP, BM, SM, AR, RM, ADM, HO, etc.
//   // ------------------------------------------
//   useEffect(() => {
//     if (!referId) return;
//     if (!profile?.superAdminId) return;

//     // FINAL REGEX: supports B.M.000001, BM000001, B-M-000001, etc.
//     const pattern = /^[A-Z.\-]{2,10}\d{1,10}$/;

//     if (pattern.test(referId)) {
//       fetchReferral(referId);
//     }
//   }, [referId, profile?.superAdminId]);

//   // Fetch Function
//   const fetchAccounts = async () => {
//     const branchId = localStorage.getItem("userId") || 56;

//     try {
//       const res = await axios.get(
//         "https://narrowitsolution.in/api/get-all-saving-account",
//         {
//           params: { superAdminId: profile.superAdminId, branchId: branchId },
//         }
//       );
//       console.log("🟢 Saving Accounts API Response:", res.data);

//       if (Array.isArray(res.data.accounts)) {
//         setSavingAccounts(res.data.accounts);
//       } else {
//         setSavingAccounts([]);
//       }
//     } catch (err) {
//       console.error("Error fetching saving accounts:", err);
//     }
//   };

//   // Effect: Fetch when user selects "linked"
//   useEffect(() => {
//     if (deductionType === "linked") {
//       fetchAccounts();
//     }
//   }, [deductionType]);

//   useEffect(() => {
//     if (!profile?.superAdminId) return; // wait until profile loads

//     const fetchSchemes = async () => {
//       setLoading(true);
//       try {
//         const res = await axios.get(
//           // `https://narrowitsolution.in/api/get-all-rddd?superAdminId=${profile.superAdminId}`
//           `https://narrowitsolution.in/api/get-all-fdmis?superAdminId=${profile.superAdminId}`
//         );
//         // console.log("schemes:",res.data)
//         if (res.data?.success) setSchemes(res.data.data);
//       } catch (err) {
//         console.error("Error fetching schemes:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchSchemes();
//   }, [profile?.superAdminId]);

//   // ====================== Handle Scheme Select ======================
//   const handleSchemeSelect = (e) => {
//     const schemeId = e.target.value;
//     setSelectedSchemeId(schemeId);
//     const scheme = schemes.find((s) => s.id === Number(schemeId));
//     setSelectedScheme(scheme || null);
//   };

//   // ====================== Fetch Customer ======================
//   const fetchCustomer = async (id) => {
//     if (!id) return;
//     try {
//       setCustomerLoading(true);
//       const branchId = localStorage.getItem("userId") || "56";
//       const res = await axios.get(
//         "https://narrowitsolution.in/api/customers-get-userId",
//         {
//           params: { userId: id, branchId },
//         }
//       );
//       console.log("Customer data:", res.data.data);

//       if (res.data?.data) {
//         const c = res.data.data;
//         setCustomerData({
//           name: c.fullName || "",
//           email: c.email || "",
//           phone: c.mobileNumber || "",
//           aadhar: c.aadhaarNumber || "",
//           pan: c.panNumber || "",
//           address: c.address || "",
//           dob: c.dateOfBirth ? c.dateOfBirth.split("T")[0] : "",
//         });
//       } else {
//         alert("No customer found with this ID");
//       }
//     } catch (err) {
//       console.error("Error fetching customer:", err);
//       alert("Error fetching customer details");
//     } finally {
//       setCustomerLoading(false);
//     }
//   };

//   // ====================== Fetch Nominee ======================
//   const fetchNominee = async (id) => {
//     if (!id) return;
//     try {
//       setNomineeLoading(true);
//       const branchId = localStorage.getItem("userId") || "56";
//       const res = await axios.get(
//         "https://narrowitsolution.in/api/customer-nominee-filter",
//         {
//           params: { customerId: id, branchId },
//         }
//       );

//       console.log("nominee details:",res.data)
//       if (res.data.success && res.data.data) {
//         const n = res.data.data;
//         console.log("nominee data:", n);
//         setNomineeData({
//           nomineeName: n.nomineeName || "",
//           dob: n.nomineeDob ? n.nomineeDob.split("T")[0] : "",
//           aadhar: n.nomineeAadhar || "",
//           pan: n.nomineePan || "",
//           mobile: n.nomineeMobile || "",
//           nomineeRelation:n.nomineeRelation||"",
//         });
//         setNomineeId(n.accountId || "");
//         setRelation(n.nomineeRelation || n.relation || "");
//       } else {
//         setNomineeData({
//           nomineeName: "",
//           dob: "",
//           aadhar: "",
//           pan: "",
//           mobile: "",
//           nomineeRelation:""
//         });
//       }
//     } catch (err) {
//       console.error("Error fetching nominee:", err);
//       alert("Error fetching nominee details");
//     } finally {
//       setNomineeLoading(false);
//     }
//   };

//   // fetch referal
//   const fetchReferral = async (id) => {
//     if (!id) return alert("Please enter Referral ID");

//     try {
//       const superAdminId = profile?.superAdminId;
//       const res = await axios.get("https://narrowitsolution.in/api/hr-employees-filter", {
//         params: { userId: id, superAdminId },
//       });

//       console.log("referal id:", res.data);
//       if (res.data.success && res.data.data) {
//         const r = res.data.data;
//         setReferralName(r.fullName || r.employeeName || r.name  || "");
//       } else {
//         setReferralName("");
//         alert("No referral found with this ID");
//       }
//     } catch (err) {
//       console.error("Error fetching referral:", err);
//       alert("Error fetching referral details");
//       setReferralName("");
//     }
//   };


//   useEffect(() => {
//     // console.log("Customer ID:", customerId);   // 👈 Yahan console karega

//     const pattern = /^CUS\d{5,10}$/;

//     if (pattern.test(customerId)) {
//       fetchCustomer(customerId);
//       fetchNominee(customerId);
//     }
//   }, [customerId]);

//   // calculation
//   const handleCalculate = (e) => {
//     e.preventDefault();

//     if (!amount || !tenure || !selectedScheme) {
//       alert("Please select a scheme and enter amount & tenure");
//       return;
//     }

//     const P = Number(amount); // Deposit amount
//     const R = Number(selectedScheme.roi || 0); // ROI %
//     const n = Number(tenure); // Tenure (months)
//     const r = R / 100; // ROI in decimal

//     if (P <= 0 || R <= 0 || n <= 0) {
//       alert("Invalid input values");
//       return;
//     }

//     let maturity = 0;
//     let totalInterest = 0;
//     let totalDeposit = 0;
//     let monthlyInterest = "";

//     // ---------------------------------------------------------
//     // FD — Fixed Deposit (Compound Interest Monthly)
//     // Formula:
//     //   maturity = P * (1 + r/12) ^ n
//     //   interest = maturity - P
//     // ---------------------------------------------------------
//     if (accountType === "FD") {
//       maturity = P * Math.pow(1 + r / 12, n);
//       totalDeposit = P;
//       totalInterest = maturity - P;
//     }

//     // ---------------------------------------------------------
//     // MIS — Monthly Income Scheme
//     // Formula:
//     //   Monthly Interest = P * r / 12
//     //
//     // Maturity = Principal only (MIS does not compound)
//     //   totalInterest = monthlyInterest * tenure
//     // ---------------------------------------------------------
//     if (accountType === "MIS") {
//       monthlyInterest = ((P * r) / 12).toFixed(2);

//       maturity = P; // MIS does not grow
//       totalDeposit = P;
//       totalInterest = (monthlyInterest * n).toFixed(2);
//     }

//     // ---------------------------------------------------------
//     // Store results
//     // ---------------------------------------------------------
//     setResults({
//       principal: totalDeposit.toFixed(2),
//       totalInterest: Number(totalInterest).toFixed(2),
//       maturityAmount: maturity.toFixed(2),
//       monthlyInterest,
//     });
//   };

//   // ====================== ChartJS ======================
//   useEffect(() => {
//     if (viewChart && canvasRef.current) {
//       if (chartRef.current) chartRef.current.destroy();

//       chartRef.current = new ChartJS(canvasRef.current, {
//         type: "doughnut",
//         data: {
//           labels: ["Principal", "Interest"],
//           datasets: [
//             {
//               data: [results.principal, results.totalInterest],
//               backgroundColor: ["#018da0ff", "#F59E0B"],
//               hoverOffset: 10,
//             },
//           ],
//         },
//         options: {
//           responsive: true,
//           plugins: { legend: { position: "bottom" } },
//         },
//       });
//     }

//     return () => {
//       if (chartRef.current) chartRef.current.destroy();
//     };
//   }, [viewChart, results]);

//   const resetForm = () => {
//     setAmount("");
//     setRoi("");
//     setTenure("");
//     setResults({ principal: 0, totalInterest: 0, maturityAmount: 0, monthlyInterest:0 });
//     setViewChart(false);
//     setCustomerId("");
//     setCustomerData({
//       name: "",
//       email: "",
//       phone: "",
//       aadhar: "",
//       pan: "",
//       dob: "",
//       address: "",
//     });
//     setNomineeId("");
//     setNomineeData({
//       nomineeName: "",
//       dob: "",
//       aadhar: "",
//       pan: "",
//       mobile: "",
//       nomineeRelation:""
//     });
//     setRelation("");
//     setreferId("");
//     setReferralName("");
//     setSelectedSchemeId("");
//     setSelectedScheme(null);
//     setDeductionType("");
//     setSelectedSavingAccount("");
//   };

//   // const handleOpenFD = (e) => {
//   //   e.preventDefault();

//   //   const payload = {
//   //     accountType,
//   //     schemes,
//   //     roi,
//   //     depositAmount,
//   //     tenureMonths,
//   //     compoundingType,
//   //     payoutFrequency,
//   //     customer: { id: customerId, ...customerData },
//   //     nominee: { id: nomineeId, ...nomineeData, relation },
//   //     referral: { id: referId, name: referralName },
//   //     payment: {
//   //       paymentMode,
//   //       receiptNumber,
//   //       chequeNumber,
//   //       bankName,
//   //       chequeDate,
//   //       upiId,
//   //       transactionId,
//   //     },
//   //   };

//   //   console.log("Open FD payload:", payload);
//   //   alert("FD/MIS account opened (mock). Check console for payload.");
//   // };



// const handleSubmit = async () => {
//   if (!customerId) return alert("Select Customer");
//   if (!selectedSchemeId) return alert("Select Scheme");
//   if (!amount) return alert("Enter Amount");
//   if (!profile?.superAdminId) return alert("Wait loading profile");

//   const payload = {
//     accountType:accountType||"",
//     customerId:customerId||"",
//     nomineeId:nomineeId||"",
//     referralId:referId||null,
//     // customerId: { id: customerId, ...customerData },
//     // nomineeId: { id: nomineeId, ...nomineeData, relation },
//     // referralId: { id: referId, name: referralName },
//     schemeId:Number(selectedSchemeId),
//     depositAmount:amount||"",
//     tenureMonths:Number(tenure)||0,
//     payoutType:payoutType||"",
//     interestPayoutFrequency:selectedScheme?.roiFrequency||"",
//     compoundingType:selectedScheme?.interestCompounding||"",
//     bonus:0,
//     deductionType:deductionType||"",
//     linkedSavingAccount:deductionType === "linked"? Number(selectedSavingAccount): null,
//     referralName:referralName||"",
//     branchId:profile.branchId||localStorage.getItem("userId"),
//     superAdminId:profile.superAdminId||null,
//     createdBy:Number(profile?.userId) || Number(customerId),
//   };

//   console.log("Payload being sent:", payload); // VERY IMPORTANT DEBUG

//   try {
//     setSubmitting(true);
//     const res = await axios.post(
//       "https://narrowitsolution.in/api/fdmis/create",
//       payload
//     );

//     if (res.data.success) {
//       alert("Deposit created");
//       resetForm();
//     } else {
//       alert(res.data.message);
//     }
//   } catch (err) {
//     console.error("Error creating deposit:", err);
//   } finally {
//     setSubmitting(false);
//   }
// };



//   return (
//     <div className="fd-mis-container">
//       {/* Top FD/MIS Grid */}
//       <form onSubmit={handleCalculate} style={{ marginBottom: 20 }}>
//         {/* ACCOUNT TYPE */}
//         <div className="fd-mis-form-grid">
//           <div className="fd-mis-input-fields">
//             <label className="fd-mis-label">Account Type :</label>
//             <select
//               value={accountType}
//               onChange={(e) => setAccountType(e.target.value)}
//               className="fd-mis-input"
//             >
//               <option>FD</option>
//               <option>MIS</option>
//             </select>
//           </div>

//           {/* Scheme */}
//           <div className="fd-mis-input-fields">
//             {/* <label className="fd-mis-label">Select Scheme :</label>
//           <select value={schemes} onChange={(e) => setSchemes(e.target.value)} className="fd-mis-input">
//             <option value="">-- Select Scheme --</option>
//             <option value="Regular FD">Regular FD</option>
//             <option value="Senior Citizen FD">Senior Citizen FD</option>
//             <option value="MIS">MIS</option>
//           </select> */}

//             <label className="fd-mis-label">Select Scheme :</label>
//             <select
//               className="fd-mis-input"
//               value={selectedSchemeId}
//               onChange={handleSchemeSelect}
//             >
//               <option value="">-- Select Scheme --</option>
//               {loading ? (
//                 <option disabled>Loading...</option>
//               ) : (
//                 schemes.map((scheme) => (
//                   <option key={scheme.id} value={scheme.id}>
//                     {scheme.serviceName} ({scheme.roiFrequency})
//                   </option>
//                 ))
//               )}
//             </select>
//           </div>

//           {/* ROI */}
//           <div className="fd-mis-input-fields">
//             <label className="fd-mis-label">ROI (%) :</label>
//             <input
//               value={selectedScheme?.roi||""}
//               readOnly
//               /*onChange={(e) => setRoi(e.target.value)}*/ className="fd-mis-input"
//               // placeholder="7.00"
//             />
//           </div>

//           {/* Min Deposit */}
//           <div className="fd-mis-input-fields">
//             <label className="fd-mis-label">Min Deposit Amount :</label>
//             <input
//               value={selectedScheme?.minDepositAmount || ""}
//               readOnly
//               className="fd-mis-input"
//             />
//           </div>

//           {/* Min Tenure */}
//           <div className="fd-mis-input-fields">
//             <label className="fd-mis-label">Min Tenure :</label>
//             <input
//               value={selectedScheme?.minTenure || ""}
//               readOnly
//               className="fd-mis-input"
//             />
//           </div>

//           {/* IF */}
//           <div className="fd-mis-input-fields">
//             <label className="fd-mis-label">ROI Frequency :</label>
//             <input
//               value={selectedScheme?.roiFrequency || ""}
//               readOnly
//               className="fd-mis-input"
//             />
//           </div>

//           {/* Lockin */}
//           <div className="fd-mis-input-fields">
//             <label className="fd-mis-label">Lockin Period (Months):</label>
//             <input
//               value={selectedScheme?.depositLockinPeriod || ""}
//               readOnly
//               className="fd-mis-input"
//             />
//           </div>

//           {/* Interest Lockin */}
//           <div className="fd-mis-input-fields">
//             <label className="fd-mis-label">Interest Lockin (Months):</label>
//             <input
//               value={selectedScheme?.interestLockinPeriod || ""}
//               readOnly
//               className="fd-mis-input"
//             />
//           </div>

//           {/* Compounding */}
//           <div className="fd-mis-input-fields">
//             <label className="fd-mis-label">Compounding Type :</label>
//             <input
//               value={selectedScheme?.interestCompounding || ""}
//               readOnly
//               className="fd-mis-input"
//             />
//             {/* <option>Simple</option>
//             <option>Compound</option> */}
//           </div>

//           {/* Deposit Amount */}
//           <div className="fd-mis-input-fields">
//             <label className="fd-mis-label">Enter Deposit Amount :</label>
//             <input
//               type="number"
//               value={amount}
//               onChange={(e) => setAmount(e.target.value)}
//               className="fd-mis-input"
//             />
//           </div>

//           {/* Tenure */}
//           <div className="fd-mis-input-fields">
//             <label className="fd-mis-label">Enter Tenure (Months) :</label>
//             <input
//               type="number"
//               value={tenure}
//               onChange={(e) => setTenure(e.target.value)}
//               className="fd-mis-input"
//             />
//           </div>

//           {/* 🔥 MIS Fields */}
//           {accountType === "MIS" && (
//             <>
//               <div className="fd-mis-input-fields">
//                 <label className="fd-mis-label">
//                   Interest Payout Frequency :
//                 </label>
//                 <select
//                   value={payoutFrequency}
//                   onChange={(e) => setPayoutFrequency(e.target.value)}
//                   className="fd-mis-input"
//                 >
//                   <option value="">Select</option>
//                   <option value="Monthly">Monthly</option>
//                   <option value="Quarterly">Quarterly</option>
//                 </select>
//               </div>

//               <div className="fd-mis-input-fields">
//                 <label className="fd-mis-label">Monthly Interest :</label>
//                 <input
//                   className="fd-mis-input"
//                   readOnly
//                   value={results.monthlyInterest}
//                   placeholder="0.00"
//                 />
//               </div>
//             </>
//           )}
//         </div>
//         {/* Buttons */}

//         <div className="fd-mis-actions">
//           <button type="submit" className="fd-mis-calc">
//             Calculate
//           </button>
//           <button type="button" className="fd-mis-reset" onClick={resetForm}>
//             Reset
//           </button>

//           <label className="fd-mis-chart-toggle">
//             <input
//               type="checkbox"
//               checked={viewChart}
//               onChange={(e) => setViewChart(e.target.checked)}
//             />
//             <span className="fd-mis-slider"></span>
//             <span className="fd-mis-toggle-label">
//               {viewChart ? "View" : "Close"} Chart
//             </span>
//           </label>
//         </div>
//       </form>

//       {/* Results */}
//       <div className="fd-mis-results-container card">
//         <div className="fd-mis-results-card-header">Results</div>
//         <div className="fd-mis-results-card-grid">
//           <div className="fd-mis-results-card-info">
//             <div className="fd-mis-results-card-row">
//               <div className="fd-mis-results-card-label">Principal Amount:</div>
//               <div className="fd-mis-results-card-value">
//                 {results.principal.toLocaleString()}
//               </div>
//             </div>
//             <div className="fd-mis-results-card-row">
//               <div className="fd-mis-results-card-label">Total Interest:</div>
//               <div className="fd-mis-results-card-value">
//                 {results.totalInterest.toLocaleString()}
//               </div>
//             </div>
//             <div className="fd-mis-results-card-row">
//               <div className="fd-mis-results-card-label">Maturity Amount:</div>
//               <div className="fd-mis-results-card-value">
//                 {results.maturityAmount.toLocaleString()}
//               </div>
//             </div>
//             {accountType === "MIS" && (
//               <>
//                 <div className="fd-mis-results-card-row">
//                   <div className="fd-mis-results-card-label">
//                     Monthly Interest:
//                   </div>
//                   <div className="fd-mis-results-card-value">
//                     {results.monthlyInterest.toLocaleString()}
//                   </div>
//                 </div>
//               </>
//             )}
//           </div>
//           {viewChart && (
//             <div className="fd-mis-chart-wrap">
//               <canvas ref={canvasRef} className="fd-mis-canvas"></canvas>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* CUSTOMER / NOMINEE / REFERRA */}
//       {/* CUSTOMER CARD */}
//       <div className="fd-mis-customer-contaier">
//         <h2 className="fd-mis-h2">
//           <FaUser /> Customer Details
//         </h2>

//         <div className="fd-mis-cn-row-box">
//           <div className="fd-mis-cn-label-cell">Customer ID:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="Enter Customer ID"
//               value={customerId}
//               onChange={(e) => setCustomerId(e.target.value)}
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">User Name:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="User Name"
//               value={customerData.name}
//               onChange={(e) =>
//                 setCustomerData({ ...customerData, name: e.target.value })
//               }
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">Email:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="Email"
//               value={customerData.email}
//               onChange={(e) =>
//                 setCustomerData({ ...customerData, email: e.target.value })
//               }
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">Phone:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="Phone"
//               value={customerData.phone}
//               onChange={(e) =>
//                 setCustomerData({ ...customerData, phone: e.target.value })
//               }
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">Aadhar:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="Aadhar"
//               value={customerData.aadhar}
//               onChange={(e) =>
//                 setCustomerData({ ...customerData, aadhar: e.target.value })
//               }
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">PAN:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="PAN"
//               value={customerData.pan}
//               onChange={(e) =>
//                 setCustomerData({ ...customerData, pan: e.target.value })
//               }
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">Date of Birth:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               type="date"
//               value={customerData.dob}
//               onChange={(e) =>
//                 setCustomerData({ ...customerData, dob: e.target.value })
//               }
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">Address:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="Address"
//               value={customerData.address}
//               onChange={(e) =>
//                 setCustomerData({ ...customerData, address: e.target.value })
//               }
//             />
//           </div>
//         </div>

//         {customerLoading && (
//           <p className="FDloading-text">Loading customer data...</p>
//         )}
//       </div>

//       {/* NOMINEE */}
//       <div className="fd-mis-nominee-container">
//         <h2 className="fd-mis-h2">
//           <FaUserFriends /> Nominee Details
//         </h2>

//         <div className="fd-mis-cn-row-box">
//           <div className="fd-mis-cn-label-cell">Nominee ID:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="Enter Nominee ID"
//               value={nomineeId}
//               onChange={(e) => setNomineeId(e.target.value)}
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">Nominee Name:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="Nominee Name"
//               value={nomineeData.nomineeName}
//               onChange={(e) =>
//                 setNomineeData({ ...nomineeData, nomineeName: e.target.value })
//               }
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">DOB:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               type="date"
//               value={nomineeData.dob}
//               onChange={(e) =>
//                 setNomineeData({ ...nomineeData, dob: e.target.value })
//               }
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">Aadhar:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="Aadhar"
//               value={nomineeData.aadhar}
//               onChange={(e) =>
//                 setNomineeData({ ...nomineeData, aadhar: e.target.value })
//               }
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">PAN:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="PAN"
//               value={nomineeData.pan}
//               onChange={(e) =>
//                 setNomineeData({ ...nomineeData, pan: e.target.value })
//               }
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">Mobile:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="Mobile"
//               value={nomineeData.mobile}
//               onChange={(e) =>
//                 setNomineeData({ ...nomineeData, mobile: e.target.value })
//               }
//             />
//           </div>

//           <div className="fd-mis-cn-label-cell">Relation:</div>
//           <div className="fd-mis-cn-value-cell">
//             <input
//               placeholder="Relation"
//               value={nomineeData.nomineeRelation}
//               onChange={(e) =>
//                 setNomineeData({ ...nomineeData, nomineeRelation: e.target.value })
//               }
//             />
//           </div>

//         </div>

//         {nomineeLoading && (
//           <p className="FDloading-text">Loading nominee data...</p>
//         )}

//         {/* Deduction Type Selector */}
//         <div className="fd-mis-deduction-field">
//           <label className="fd-mis-deduction-label">Deduction Type:</label>
//           <select
//             value={deductionType}
//             onChange={(e) => setDeductionType(e.target.value)}
//             className="fd-mis-deduction-input"
//           >
//             <option value="manual">Manual Deposit</option>
//             <option value="linked">Deduct from Saving Account</option>
//           </select>
//         </div>

//         {/* Show Saving Account Dropdown if Linked Selected */}
//         {deductionType === "linked" && (
//           <div className="fd-mis-deduction-field">
//             <label className="fd-mis-deduction-label">
//               Select Saving Account:
//             </label>
//             <select
//               value={selectedSavingAccount}
//               onChange={(e) => setSelectedSavingAccount(e.target.value)}
//               className="fd-mis-deduction-input"
//             >
//               <option value="">-- Select Saving Account --</option>
//               {savingAccounts.map((acc) => (
//                 <option key={acc.id} value={acc.id}>
//                   {acc.accountNumber}-{acc.customerName}—₹
//                   {acc.currentBalance?.toLocaleString()}
//                 </option>
//               ))}
//             </select>
//           </div>
//         )}
//       </div>

//       {/* REFERRAL */}
//       <div className="fd-mis-referral-container">
//         <h2 className="fd-mis-h2">
//           <FaIdBadge /> Referral Details
//         </h2>

//         <div className="fd-mis-referal-row">
//           <div className="fd-mis-referal-column">
//             <label>Referral ID</label>
//             <input
//               placeholder="Enter Referral ID"
//               value={referId}
//               onChange={(e) => setreferId(e.target.value)}
//             />
//           </div>
//           <div className="fd-mis-referal-column">
//             <label>Referral Name</label>
//             <input
//               placeholder="Referral Name"
//               value={referralName}
//               readOnly
//               // onChange={(e) => setReferralName(e.target.value)}
//             />
//           </div>
//         </div>

//         <button
//           type="button"
//           className="fd-mis-referal-submit-btn"
//           disabled={submitting}
//           onClick={handleSubmit}
//         >
//           {submitting ? "Opening..." : `Open ${accountType}`}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default FDMIS;




// src/components/FDMIS.jsx
import React, { useEffect, useRef, useState } from "react";
import { FaIdBadge, FaUser, FaUserFriends } from "react-icons/fa";
import "./FDD.css"; // keep your styles
import { Chart as ChartJS } from "chart.js/auto";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "../../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { toast } from "react-toastify";

const FDMIS = () => {
  const dispatch = useDispatch();
  const { profile } = useSelector((s) => s.userProfile || {});
  const canvasRef = useRef(null);
  const chartRef = useRef(null);

  // ====== UI / Loading states ======
  const [loading, setLoading] = useState(false);
  const [customerLoading, setCustomerLoading] = useState(false);
  const [nomineeLoading, setNomineeLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  // ====== Schemes & accounts ======
  const [schemes, setSchemes] = useState([]);
  const [loadingSchemes, setLoadingSchemes] = useState(false);
  const [savingAccounts, setSavingAccounts] = useState([]);

  // ====== Form states ======
  const [accountType, setAccountType] = useState("FD"); // "FD" or "MIS"
  const [selectedSchemeId, setSelectedSchemeId] = useState("");
  const [selectedScheme, setSelectedScheme] = useState(null);

  const [amount, setAmount] = useState(""); // deposit amount
  const [tenure, setTenure] = useState(""); // months
  const [payoutType, setPayoutType] = useState("On Maturity");
  const [payoutFrequency, setPayoutFrequency] = useState(""); // for MIS
  const [deductionType, setDeductionType] = useState("manual");
  const [selectedSavingAccount, setSelectedSavingAccount] = useState("");
  const [relation,setRelation]=useState("")

  // customer/nominee/referral
  const [customerId, setCustomerId] = useState("");
  const [customerData, setCustomerData] = useState({
    name: "",
    email: "",
    phone: "",
    aadhar: "",
    pan: "",
    dob: "",
    address: "",
  });

  const [nomineeId, setNomineeId] = useState("");
  const [nomineeData, setNomineeData] = useState({
    nomineeName: "",
    dob: "",
    aadhar: "",
    pan: "",
    mobile: "",
    nomineeRelation: "",
  });

  const [referId, setReferId] = useState("");
  const [referralData,setReferralData]=useState("");
  const [referralName, setReferralName] = useState("");

  // calculation results (keep as numbers)
  const [results, setResults] = useState({
    principal: 0,
    totalInterest: 0,
    maturityAmount: 0,
    monthlyInterest: 0,
  });

  // chart toggle
  const [viewChart, setViewChart] = useState(false);

  // ====== Fetch user profile on mount ======
  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  // ====== Fetch schemes when profile loaded ======
  useEffect(() => {
    if (!profile?.superAdminId) return;

    const fetchSchemes = async () => {
      setLoadingSchemes(true);
      try {
        const res = await axios.get(
          `https://narrowitsolution.in/api/get-all-fdmis?superAdminId=${profile.superAdminId}`
        );
        if (res.data?.success) {
          setSchemes(Array.isArray(res.data.data) ? res.data.data : []);
        } else {
          setSchemes([]);
          console.warn("Schemes fetch responded but success=false", res.data);
        }
      } catch (err) {
        console.error("Error fetching schemes:", err?.response?.data || err);
        setSchemes([]);
      } finally {
        setLoadingSchemes(false);
      }
    };

    fetchSchemes();
  }, [profile?.superAdminId]);

  // ====== Fetch saving accounts if deductionType === 'linked' ======
  const fetchSavingAccounts = async () => {
    if (!profile?.superAdminId) return;
    const branchId = Number(profile?.branchId) || Number(localStorage.getItem("userId")) || 56;

    try {
      const res = await axios.get("https://narrowitsolution.in/api/get-all-saving-account", {
        params: { superAdminId: profile.superAdminId, branchId },
      });
      if (Array.isArray(res.data.accounts)) setSavingAccounts(res.data.accounts);
      else setSavingAccounts([]);
    } catch (err) {
      console.error("Error fetching saving accounts:", err?.response?.data || err);
      setSavingAccounts([]);
    }
  };

  useEffect(() => {
    if (deductionType === "linked") fetchSavingAccounts();
  }, [deductionType, profile?.superAdminId]);

  // ====== Scheme select handler ======
  const handleSchemeSelect = (e) => {
    const id = e.target.value;
    setSelectedSchemeId(id);
    const found = schemes.find((s) => Number(s.id) === Number(id));
    setSelectedScheme(found || null);
  };

  // ====== Fetch Customer ======
const fetchCustomer = async (id) => {
  if (!id) return;
  try {
    setCustomerLoading(true);
    const branchId = Number(localStorage.getItem("userId")) || 56;

    const res = await axios.get("https://narrowitsolution.in/api/customers-get-userId", {
      params: { userId: id, branchId },
    });

    const c = res?.data?.data;
    console.log("customer data:",c)
    if (c) {
      setCustomerData({
        id: c.id || id, // add ID in case needed
        name: c.fullName || "",
        email: c.email || "",
        phone: c.mobileNumber || "",
        aadhar: c.aadhaarNumber || "",
        pan: c.panNumber || "",
        address: c.address || "",
        dob: c.dateOfBirth ? c.dateOfBirth.split("T")[0] : "",
      });
    } else {
      setCustomerData({
        id: id,
        name: "",
        email: "",
        phone: "",
        aadhar: "",
        pan: "",
        address: "",
        dob: "",
      });
    }
  } catch (err) {
    console.error("Error fetching customer:", err?.response?.data || err);
    toast.error("Error fetching customer details");
  } finally {
    setCustomerLoading(false);
  }
};


  // ====== Fetch Nominee ======
const fetchNominee = async (id) => {
  if (!id) return;
  try {
    setNomineeLoading(true);
    const branchId = Number(localStorage.getItem("userId")) || 56;

    const res = await axios.get("https://narrowitsolution.in/api/customer-nominee-filter", {
      params: { customerId: id, branchId },
    });

    const n = res?.data?.data;
    console.log("nominee data:",n)
    if (res.data?.success && n) {
      setNomineeData({
        nomineeName: n.nomineeName || "",
        dob: n.nomineeDob ? n.nomineeDob.split("T")[0] : "",
        aadhar: n.nomineeAadhar || "",
        pan: n.nomineePan || "",
        mobile: n.nomineeMobile || "",
        nomineeRelation: n.nomineeRelation || n.relation || "",
        id:n.id||id,
      });
      setNomineeId(n.accountId || null);
      setRelation(n.nomineeRelation || n.relation || "");
    } else {
      setNomineeData({
        nomineeName: "",
        dob: "",
        aadhar: "",
        pan: "",
        mobile: "",
        nomineeRelation: "",
      });
      setNomineeId(null);
      setRelation("");
    }
  } catch (err) {
    console.error("Error fetching nominee:", err?.response?.data || err);
    toast.error("Error fetching nominee details");
  } finally {
    setNomineeLoading(false);
  }
};


  // ====== Fetch Referral ======
const fetchReferral = async (id) => {
  if (!id) return alert("Please enter Referral ID");

  try {
    const superAdminId = profile?.superAdminId;
    const res = await axios.get("https://narrowitsolution.in/api/hr-employees-filter", {
      params: { userId: id, superAdminId },
    });

    const r = res?.data?.data;
    console.log("referal data:",r.id)
    if (res.data?.success && r) {
      setReferralName(r.fullName || r.employeeName || r.name || "");
      setReferralData(r.id);
    } else {
      setReferralName("");
      toast.error("No referral found with this ID");
    }
  } catch (err) {
    console.error("Error fetching referral:", err?.response?.data || err);
    toast.error("Error fetching referral details");
    setReferralName("");
  }
};


  // ====== Auto-fetch customer & nominee when customerId pattern matches ======
  useEffect(() => {
    const pattern = /^CUS\d{3,10}$/; // adjust pattern as per your IDs
    if (!customerId) return;
    // if you want auto-fetch only when pattern matches:
    if (pattern.test(customerId)) {
      fetchCustomer(customerId);
      fetchNominee(customerId);
    } else {
      // still allow manual fetch if you want:
      // fetchCustomer(customerId);
    }
  }, [customerId]);

  // ====== Auto-fetch referral when referId looks valid ======
  useEffect(() => {
    if (!referId || !profile?.superAdminId) return;
    const pattern = /^[A-Z.\-]{2,10}\d{1,10}$/;
    if (pattern.test(referId)) fetchReferral(referId);
  }, [referId, profile?.superAdminId]);

  // ====== Calculation ======
  const handleCalculate = (e) => {
    e.preventDefault();

    if (!amount || !tenure || !selectedScheme) {
      toast.warn("Please select a scheme and enter amount & tenure");
      return;
    }

    const P = Number(amount);
    const R = Number(selectedScheme.roi || selectedScheme?.roi || 0);
    const n = Number(tenure);
    const r = R / 100;
    // console.log("so these are the values....",P,R,n,r);

    if (!P || !R || !n) {
      toast.warn("Invalid input values");
      return;
    }

    let maturity = 0;
    let totalInterest = 0;
    let monthlyInterest = 0;

    // if (accountType === "FD") {
    //   // monthly compounding assumption if roiFrequency monthly
    //   maturity = P * Math.pow(1 + r / 12, n);
    //   totalInterest = maturity - P;
    //   monthlyInterest = (totalInterest / n).toFixed(2);
    // } 
    
     if (accountType === "FD") {
        const compoundingMap = {
          Monthly: 12,
          Quarterly: 4,
          Yearly: 1,
        };

        const compounding =
          compoundingMap[selectedScheme?.interestCompounding] ?? 12;
      //  console.log("compounidng is ", compounding);
        const years = n / 12; // because tenure is in months
        // console.log("years are ",years);
        maturity = P * Math.pow(1 + r / compounding, compounding * years);
        // console.log("maturity amount is ", maturity);

        totalInterest = maturity - P;

        // average monthly earning (for display only)
        monthlyInterest = totalInterest / n;
      }
    else {
      // MIS: monthly payout interest; principal stays same
      monthlyInterest = (P * r) / 12;
      totalInterest = monthlyInterest * n;
      maturity = P;
    }

    setResults({
      principal: Number(P.toFixed(2)),
      totalInterest: Number(Number(totalInterest).toFixed(2)),
      maturityAmount: Number(Number(maturity).toFixed(2)),
      monthlyInterest: Number(Number(monthlyInterest).toFixed(2)),
    });

    // auto open chart after calculation
    setViewChart(true);
  };

  // ====== Chart rendering ======
  useEffect(() => {
    if (!viewChart || !canvasRef.current) return;

    try {
      // destroy previous
      if (chartRef.current) {
        try {
          chartRef.current.destroy();
        } catch (e) {
          // ignore
        }
      }

      chartRef.current = new ChartJS(canvasRef.current, {
        type: "doughnut",
        data: {
          labels: ["Principal", "Interest"],
          datasets: [
            {
              data: [results.principal || 0, results.totalInterest || 0],
              backgroundColor: ["#018da0ff", "#F59E0B"],
              hoverOffset: 10,
            },
          ],
        },
        options: {
          responsive: true,
          plugins: { legend: { position: "bottom" } },
        },
      });
    } catch (err) {
      console.error("Chart error:", err);
    }

    return () => {
      try {
        if (chartRef.current) chartRef.current.destroy();
      } catch (e) {}
    };
  }, [viewChart, results]);

  // ====== Reset form ======
  const resetForm = () => {
    setAmount("");
    setTenure("");
    setResults({ principal: 0, totalInterest: 0, maturityAmount: 0, monthlyInterest: 0 });
    setViewChart(false);
    setCustomerId("");
    setCustomerData({ name: "", email: "", phone: "", aadhar: "", pan: "", dob: "", address: "" });
    setNomineeId("");
    setNomineeData({ nomineeName: "", dob: "", aadhar: "", pan: "", mobile: "", nomineeRelation: "" });
    // setRelation && setRelation(""); // if relation exists earlier
    setReferId("");
    setReferralName("");
    setSelectedSchemeId("");
    setSelectedScheme(null);
    setDeductionType("manual");
    setSelectedSavingAccount("");
  };

  // ====== Submit (open deposit) ======
const handleSubmit = async () => {
  // ===== Basic Validations =====
  if (!customerId) return alert("Select Customer");
  if (!selectedSchemeId) return alert("Select Scheme");
  if (!amount) return alert("Enter Amount");
  if (!profile?.superAdminId) return alert("Wait loading profile");


  // ===== Final Payload (Matches Backend Exactly) =====
  const payload = {
    accountType: accountType || "",
    customerId: Number(customerData.id) || null,
    nomineeId: nomineeData?.id ? Number(nomineeData.id) : null,
    schemeId: Number(selectedSchemeId) || null,
    depositAmount: Number(amount) || null,
    tenureMonths: Number(tenure) || null,
    payoutType: payoutType || "",
    interestPayoutFrequency:
      selectedScheme?.roiFrequency || payoutFrequency || "",
    compoundingType: selectedScheme?.interestCompounding || "",
    bonus: 0,
    deductionType: deductionType || "manual",
    linkedSavingAccount:
      deductionType === "linked" ? Number(selectedSavingAccount) : null,
    referralId: Number(referralData) || null,
    referralName: referralName || "",
    branchId:
      Number(profile?.branchId) ||
      Number(localStorage.getItem("userId")) ||
      null,
    superAdminId: Number(profile?.superAdminId) || null,
    createdBy: Number(localStorage.getItem("userId")) || null,
  };


  console.log("Payload being sent:", payload);

  // ===== API Call =====
  try {
    setSubmitting(true);

    const res = await axios.post(
      "https://narrowitsolution.in/api/fdmis/create",
      payload
    );

    if (res.data?.success) {
      toast.success("Deposit created");
      resetForm();
    } else {
      toast.error(res.data?.message || "Failed to create deposit");
    }
  } catch (err) {
    console.error("Error creating deposit:", err?.response?.data || err);
    const msg =
      err?.response?.data?.message ||
      err?.message ||
      "Server error";
    toast.error(`Error: ${msg}`);
  } finally {
    setSubmitting(false);
  }
};



  // ====== Render ======
  return (
    <div className="fd-mis-container">
      {/* Top FD/MIS Grid */}
      <h2 className="fd-mis-heading">
        {accountType === "FD"
          ? "FD Account Form"
          : "MIS Account Form"}
      </h2 >
      <form onSubmit={handleCalculate} style={{ marginBottom: 20 }}>
        <h2 className="fd-mis-h2">ACCOUNT INFORMATION</h2>
        <div className="fd-mis-form-grid">
          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Account Type :</label>
            <select value={accountType} onChange={(e) => setAccountType(e.target.value)} className="fd-mis-input">
              <option value="FD">FD</option>
              <option value="MIS">MIS</option>
            </select>
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Select Scheme :</label>
            <select className="fd-mis-input" value={selectedSchemeId} onChange={handleSchemeSelect}>
              <option value="">-- Select Scheme --</option>
              {loadingSchemes ? (
                <option disabled>Loading...</option>
              ) : (
                schemes.map((scheme) => (
                  <option key={scheme.id} value={scheme.id}>
                    {scheme.serviceName} ({scheme.roiFrequency})
                  </option>
                ))
              )}
            </select>
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">ROI (%) :</label>
            <input className="fd-mis-input" value={selectedScheme?.roi ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Min Deposit Amount :</label>
            <input className="fd-mis-input" value={selectedScheme?.minDepositAmount ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Min Tenure :</label>
            <input className="fd-mis-input" value={selectedScheme?.minTenure ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">ROI Frequency :</label>
            <input className="fd-mis-input" value={selectedScheme?.roiFrequency ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Lockin Period (Months):</label>
            <input className="fd-mis-input" value={selectedScheme?.depositLockinPeriod ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Interest Lockin (Months):</label>
            <input className="fd-mis-input" value={selectedScheme?.interestLockinPeriod ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Compounding Type :</label>
            <input className="fd-mis-input" value={selectedScheme?.interestCompounding ?? ""} readOnly />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Enter Deposit Amount :</label>
            <input type="number" value={amount} onChange={(e) => setAmount(e.target.value)} className="fd-mis-input" />
          </div>

          <div className="fd-mis-input-fields">
            <label className="fd-mis-label">Enter Tenure (Months) :</label>
            <input type="number" value={tenure} onChange={(e) => setTenure(e.target.value)} className="fd-mis-input" />
          </div>

          {accountType === "MIS" && (
            <>
              <div className="fd-mis-input-fields">
                <label className="fd-mis-label">Interest Payout Frequency :</label>
                <select value={payoutFrequency} onChange={(e) => setPayoutFrequency(e.target.value)} className="fd-mis-input">
                  <option value="">Select</option>
                  <option value="Monthly">Monthly</option>
                  <option value="Quarterly">Quarterly</option>
                </select>
              </div>

              <div className="fd-mis-input-fields">
                <label className="fd-mis-label">Monthly Interest :</label>
                <input className="fd-mis-input" readOnly value={results.monthlyInterest ?? 0} />
              </div>
            </>
          )}
        </div>

        <div className="fd-mis-actions">
          <button type="submit" className="fd-mis-calc">
            Calculate
          </button>
          <button type="button" className="fd-mis-reset" onClick={resetForm}>
            Reset
          </button>

          {/* <label className="fd-mis-chart-toggle">
            <input type="checkbox" checked={viewChart} onChange={(e) => setViewChart(e.target.checked)} />
            <span className="fd-mis-slider"></span>
            <span className="fd-mis-toggle-label">{viewChart ? "View" : "Close"} Chart</span>
          </label> */}
        </div>
      </form>

      {/* Results */}
      <div className="fd-mis-results-container card">
        <div className="fd-mis-results-card-header">Results</div>
        <div className="fd-mis-results-card-grid">
          <div className="fd-mis-results-card-info">
            <div className="fd-mis-results-card-row">
              <div className="fd-mis-results-card-label">Principal Amount:</div>
              <div className="fd-mis-results-card-value">{Number(results.principal || 0).toLocaleString()}</div>
            </div>
            <div className="fd-mis-results-card-row">
              <div className="fd-mis-results-card-label">Total Interest:</div>
              <div className="fd-mis-results-card-value">{Number(results.totalInterest || 0).toLocaleString()}</div>
            </div>
            <div className="fd-mis-results-card-row">
              <div className="fd-mis-results-card-label">Maturity Amount:</div>
              <div className="fd-mis-results-card-value">{Number(results.maturityAmount || 0).toLocaleString()}</div>
            </div>

            {accountType === "MIS" && (
              <div className="fd-mis-results-card-row">
                <div className="fd-mis-results-card-label">Monthly Interest:</div>
                <div className="fd-mis-results-card-value">{Number(results.monthlyInterest || 0).toLocaleString()}</div>
              </div>
            )}
          </div>

          {/* {viewChart && (
            <div className="fd-mis-chart-wrap">
              <canvas ref={canvasRef} className="fd-mis-canvas" />
            </div>
          )} */}
        </div>
      </div>

      {/* CUSTOMER / NOMINEE / REFERRAL */}
      <div className="fd-mis-customer-contaier">
        <h3 className="fd-mis-h3">
          <FaUser /> Customer Details
        </h3>

        <div className="fd-mis-cn-row-box">
          <div className="fd-mis-cn-label-cell">Customer ID:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Enter Customer ID" value={customerId} onChange={(e) => setCustomerId(e.target.value)} />
          </div>

          <div className="fd-mis-cn-label-cell">User Name:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="User Name" value={customerData.name} onChange={(e) => setCustomerData({ ...customerData, name: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Email:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Email" value={customerData.email} onChange={(e) => setCustomerData({ ...customerData, email: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Phone:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Phone" value={customerData.phone} onChange={(e) => setCustomerData({ ...customerData, phone: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Aadhar:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Aadhar" value={customerData.aadhar} onChange={(e) => setCustomerData({ ...customerData, aadhar: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">PAN:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="PAN" value={customerData.pan} onChange={(e) => setCustomerData({ ...customerData, pan: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Date of Birth:</div>
          <div className="fd-mis-cn-value-cell">
            <input type="date" value={customerData.dob} onChange={(e) => setCustomerData({ ...customerData, dob: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Address:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Address" value={customerData.address} onChange={(e) => setCustomerData({ ...customerData, address: e.target.value })} />
          </div>
        </div>

        {customerLoading && <p className="FDloading-text">Loading customer data...</p>}
      </div>

      {/* NOMINEE */}
      <div className="fd-mis-nominee-container">
        <h3 className="fd-mis-h3">
          <FaUserFriends /> Nominee Details
        </h3>

        <div className="fd-mis-cn-row-box">
          <div className="fd-mis-cn-label-cell">Nominee ID:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Enter Nominee ID" value={nomineeId} onChange={(e) => setNomineeId(e.target.value)} />
          </div>

          <div className="fd-mis-cn-label-cell">Nominee Name:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Nominee Name" value={nomineeData.nomineeName} onChange={(e) => setNomineeData({ ...nomineeData, nomineeName: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">DOB:</div>
          <div className="fd-mis-cn-value-cell">
            <input type="date" value={nomineeData.dob} onChange={(e) => setNomineeData({ ...nomineeData, dob: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Aadhar:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Aadhar" value={nomineeData.aadhar} onChange={(e) => setNomineeData({ ...nomineeData, aadhar: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">PAN:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="PAN" value={nomineeData.pan} onChange={(e) => setNomineeData({ ...nomineeData, pan: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Mobile:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Mobile" value={nomineeData.mobile} onChange={(e) => setNomineeData({ ...nomineeData, mobile: e.target.value })} />
          </div>

          <div className="fd-mis-cn-label-cell">Relation:</div>
          <div className="fd-mis-cn-value-cell">
            <input placeholder="Relation" value={nomineeData.nomineeRelation} onChange={(e) => setNomineeData({ ...nomineeData, nomineeRelation: e.target.value })} />
          </div>
        </div>

        {nomineeLoading && <p className="FDloading-text">Loading nominee data...</p>}

        {/* Deduction Type Selector */}
        <div className="fd-mis-deduction-field">
          <label className="fd-mis-deduction-label">Deduction Type:</label>
          <select value={deductionType} onChange={(e) => setDeductionType(e.target.value)} className="fd-mis-deduction-input">
            <option value="manual">Manual Deposit</option>
            <option value="linked">Deduct from Saving Account</option>
          </select>
        </div>

        {/* Show Saving Account Dropdown if Linked Selected */}
        {deductionType === "linked" && (
          <div className="fd-mis-deduction-field">
            <label className="fd-mis-deduction-label">Select Saving Account:</label>
            <select value={selectedSavingAccount} onChange={(e) => setSelectedSavingAccount(e.target.value)} className="fd-mis-deduction-input">
              <option value="">-- Select Saving Account --</option>
              {savingAccounts.map((acc) => (
                <option key={acc.id} value={acc.id}>
                  {acc.accountNumber}-{acc.customerName}—₹{Number(acc.currentBalance || 0).toLocaleString()}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>

      {/* REFERRAL */}
      <div className="fd-mis-referral-container">
        <h3 className="fd-mis-h3">
          <FaIdBadge /> Referral Details
        </h3>

        <div className="fd-mis-referal-row">
          <div className="fd-mis-referal-column">
            <label>Referral ID</label>
            <input placeholder="Enter Referral ID" value={referId} onChange={(e) => setReferId(e.target.value)} />
          </div>
          <div className="fd-mis-referal-column">
            <label>Referral Name</label>
            <input placeholder="Referral Name" value={referralName} readOnly />
          </div>
        </div>

      </div>
        <div style={{textAlign: "center" }}>
          <button type="button" className="fd-mis-referal-submit-btn" disabled={submitting} onClick={handleSubmit}>
            {submitting ? "Opening..." : `Open ${accountType} Account`}
          </button>
        </div>
    </div>
  );
};

export default FDMIS;
